import { createApp } from 'vue';
import ElementPlus from 'element-plus'
import router from './router/main'
import App from './App.vue'
import 'element-plus/dist/index.css'
import './assets/css/main.css'

const app = createApp(App);

// 去掉Vue warn警告
app.config.warnHandler = () => null;

app.use(router);
app.use(ElementPlus);
app.mount('#app');